import { useState, useEffect } from 'react';

/** Fetch all ZCTA-related datasets once. Single source of truth for crime, rent, livability data. */
export function useZctaData() {
  const [zctaCrimeData, setZctaCrimeData] = useState(null);
  const [zctaMedianRent, setZctaMedianRent] = useState(null);
  const [zctaLivabilityData, setZctaLivabilityData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const base = process.env.PUBLIC_URL || '';

    Promise.all([
      fetch(`${base}/data/crime-risk-by-zcta.json`).then((r) => (r.ok ? r.json() : null)).catch(() => null),
      fetch(`${base}/data/median-rent-by-zcta.json`).then((r) => (r.ok ? r.json() : null)).catch(() => null),
      fetch(`${base}/data/livability-by-zcta.json`).then((r) => (r.ok ? r.json() : null)).catch(() => null),
    ]).then(([crime, rent, livability]) => {
      if (cancelled) return;
      setZctaCrimeData(crime || null);
      setZctaMedianRent(rent && typeof rent === 'object' ? rent : null);
      setZctaLivabilityData(livability && typeof livability === 'object' ? livability : null);
    });

    return () => { cancelled = true; };
  }, []);

  return { zctaCrimeData, zctaMedianRent, zctaLivabilityData };
}
